import { TextField } from '../../TextField/TextField';
import { InternalFieldRenderer } from '../Types';

export const renderTextField: InternalFieldRenderer = (
  props,
  { value, ...field },
  fieldState,
) => (
  <TextField
    fullWidth
    error={fieldState.invalid}
    helperText={fieldState.message}
    value={value ?? ''}
    {...field}
    {...props}
  />
);
